import { Space, SpaceApiFilter } from '@energybox/react-ui-library/dist/types';
import { fetchApi } from '../utils/apiUtils';
import { setSpacesApiFilter } from './spaces';

export const fetchSpaces = (filter?: SpaceApiFilter): Promise<Space[]> =>
  fetchApi({
    endpoint: setSpacesApiFilter(filter),
  });
